export default {"src":"/_next/static/media/logo.b2760f6e.svg","height":979,"width":985,"blurWidth":0,"blurHeight":0};